import { gql } from '@apollo/client';
const GET_ORDERS_STATS = gql `
  query GetOrdersStats($statuses: [String], $seasonId: ID) {
    me {
      id
      ordersStats(statuses: $statuses, seasonId: $seasonId) {
        delayedOrdersIds
        plannedOrdersIds
      }
    }
  }
`;
export default GET_ORDERS_STATS;
